import { VizTypes } from '@mode/shared/contract-common';

export { VizTypes };

export type RowHeight = 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large' | 'full' | 'auto';
const ROW_EXTRA_SMALL_HEIGHT: RowHeight = 'extra-small';
const ROW_SMALL_HEIGHT: RowHeight = 'small';
const ROW_MEDIUM_HEIGHT: RowHeight = 'medium';
const ROW_LARGE_HEIGHT: RowHeight = 'large';
const ROW_EXTRA_LARGE_HEIGHT: RowHeight = 'extra-large';
const ROW_FULL_HEIGHT: RowHeight = 'full';
const ROW_AUTO_HEIGHT: RowHeight = 'auto';
const ROW_DEFAULT_HEIGHT: RowHeight = ROW_MEDIUM_HEIGHT;

export const RowHeights = {
  ExtraSmall: ROW_EXTRA_SMALL_HEIGHT,
  Small: ROW_SMALL_HEIGHT,
  Medium: ROW_MEDIUM_HEIGHT,
  Large: ROW_LARGE_HEIGHT,
  ExtraLarge: ROW_EXTRA_LARGE_HEIGHT,
  Full: ROW_FULL_HEIGHT,
  Auto: ROW_AUTO_HEIGHT,
  Default: ROW_DEFAULT_HEIGHT,
};
